import { useState } from "react";
import { useLoading } from '../../components/globalloaders/LoadingContext';
import axios from "axios";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
import { setAccessToken } from "../../utils/auth/tokenStore";

const Login = () => {

  const { isLoading, setIsLoading } = useLoading();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async () => {
    if (isLoading) return;
    if (!form.username || !form.password) {
      toast.warning("Username and password are required");
      return;
    }
    setIsLoading(true);
    try {
      const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(form), process.env.REACT_APP_SECURE_KEY).toString();
      const res = await axios.post(`${process.env.REACT_APP_URI}/auth/login`, { data: encryptedData }, { withCredentials: true });
      if (res.data.success) {
        setAccessToken(res.data.accessToken);
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message || "Authentication failed");
      }
    } catch (err) {
      console.log("Unable to authenticate error:")
      toast.error(err?.response?.data?.message || "Network Error Unable to authenticate");
    } finally {
      setIsLoading(false);
      return;
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-indigo-50 via-white to-white px-4">
        <div className="w-full max-w-md space-y-6">
          <div className={`flex items-center justify-center space-x-3`}>
            <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-lg bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 text-white font-bold text-md sm:text-lg">
              WS
            </div>
            <div className="flex flex-col">
              <span className="text-xl sm:text-2xl font-bold tracking-tight bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 bg-clip-text text-transparent">
                MBEO Workspace
              </span>
              <span className="text-xs text-center text-gray-500">Smart by Logic. Built for You.</span>
            </div>
          </div>
          <div className="bg-white border border-gray-200 rounded-2xl shadow-md p-6 sm:p-7">
            <div className="mb-6 text-center">
              <h2 className="text-lg font-semibold text-gray-800">
                Secure System Access
              </h2>
              <p className="text-xs text-gray-500 mt-1">
                Authentication required
              </p>
            </div>

            <div className="space-y-5">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Username
                </label>
                <input
                  name="username"
                  type="text"
                  value={form.username}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm
                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Password
                </label>
                <input
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm
                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>

              <button
                type="button"
                disabled={isLoading}
                className="w-full mt-2 bg-indigo-600 hover:bg-indigo-700
              text-white font-semibold text-sm py-2.5 rounded-lg transition
              disabled:opacity-60"
                onClick={handleSubmit}
              >
                {isLoading ? "Authenticating…" : "Authenticate"}
              </button>
            </div>
          </div>
          <p className="text-[11px] text-gray-400 text-center">
            © {new Date().getFullYear()} MBEOWS - v{process.env.REACT_APP_VERSION}
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;